<template>
  <div class="btn-group">
    <slot :buttonParams="innerParams"></slot>
  </div>
</template>
<script>
/**
 * @class ProcessButtonList
 *
 * @description rendering process buttons in templates
 */
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    ids: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      innerParams: {},
    }
  },
  mounted() {
    this.innerParams = this.params
  },
  watch: {
    params: {
      immediate: true,
      deep: true,
      handler: function () {
        this.innerParams = this.params
      },
    },
  },
}
</script>
